import { render, staticRenderFns } from "./PartnerStoreMappingMaintenance.vue?vue&type=template&id=2cb10c8d&"
import script from "./PartnerStoreMappingMaintenance.vue?vue&type=script&lang=js&"
export * from "./PartnerStoreMappingMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports